import type {BulkUpdateEntityType} from 'types';
import type {Data} from 'schemaDefinition/types';
import type {CodeListId} from 'services/codelists/types';
import type {Schemas} from 'api/dto.generated';

export const INTERNATIONAL_AGENTS = ['4253', '4252', '4296', '4476', '5913'];

export type FilterType = Schemas.AvailableFilter['type'];
export type FilterOperation = Schemas.Filter['operation'] | 'BETWEEN';
export type FilterOperator = Schemas.Filter['operator'];
export type Filter = Omit<
  Schemas.Filter,
  'value' | 'operator' | 'operation'
> & {
  values?: Array<string>;
  operation: FilterOperation;
  generated?: boolean;
};
export type CurrentFilterType = Filter & {
  id: number;
  hidden?: boolean;
};
export type CustomFilterType = CurrentFilterType & {
  hidden: true;
};
export type GeneratedFilterType = CurrentFilterType & {
  generated: true;
};
export type FilterSet = Omit<Schemas.FilterSet, 'filters'> & {
  filters: Array<Filter | CustomFilterType>;
};
export type CreateFilterSet = Omit<FilterSet, 'id'>;

export type Column = Omit<Schemas.Column, 'codelistId'> & {
  codelistId?: Schemas.CodelistDto['id'];

  /**
   *  All columns are available on type manifestation, but only a few
   *  are available when viewmode is work.
   */
  workColumn?: boolean;
};
export type ColumnWithLabel = Column & {
  label: string;
};

export type ColumnSet = Schemas.ColumnSet;
export type Pageable = Required<Omit<Schemas.Pageable, 'sort'>> & {
  sort?: string;
};

export type ViewMode = BulkUpdateEntityType;
export type DataRow = Schemas.ExportRow;
export type DataResponse = {
  hits: number;
  rows: Data[];
};

export type AvailableFilter = Omit<
  Schemas.AvailableFilter,
  'codelistId' | 'operations'
> & {
  operations: Array<FilterOperation>;
  codelistId?: Schemas.CodelistDto['id'];
  generated?: boolean;
};

export type AvailableFilterWithLabel = AvailableFilter & {
  label: string;
  codelistId?: CodeListId;
};

/*
  Submit does not use distinctOn
  Export does not use pagination parameters
 */
export type PostInfoApiArgs = Schemas.ExportRequest & {
  page?: Pageable['page'];
  size?: Pageable['size'];
  sort?: Pageable['sort'];
};
export type PostInfoArgs = Omit<
  PostInfoApiArgs,
  'type' | 'filters' | 'eans' | 'workIds'
> & {
  type: ViewMode;
  filters: Filter[];
};
